module.exports = __webpack_public_path__ + "static/media/shield.1dc09dfa.svg";